export default "__VITE_ASSET__DlOaZeiy__"